export default __webpack_public_path__ + "static/media/operator.abd0ac42.svg";